<template>
    <div class="EvieChatMessage" :class="`EvieChatMessage--${message.role.toLowerCase()}`">
        <EvieChatMessageUserBubble v-if="isUser" :message="message" :is-last="isLast" :is-settled="isSettled" />
        <EvieChatMessageAssistantBubble
            v-else
            :message="message"
            :is-last="isLast"
            :is-settled="isSettled"
            @retry="$emit('retry', $event)"
            @new-chat="$emit('new-chat')"
            @feedback="$emit('feedback', $event)"
        />
    </div>
</template>

<style lang="scss">
.EvieChatMessage {
    display: flex;
    padding: 4px 16px;

    &--user {
        justify-content: flex-end;
    }

    &--agent {
        justify-content: flex-start;
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { ChatMessageRole } from '@evidentid/tprm-portal-lib/models/evie/ChatMessageRole.model';

    import { EvieThreadMessage } from '@/modules/evie-ai/models/EvieThreadMessage.model';

    import EvieChatMessageAssistantBubble from './sub-components/EvieChatMessageAssistantBubble.vue';
    import EvieChatMessageUserBubble from './sub-components/EvieChatMessageUserBubble.vue';

    export default defineComponent({
        name: 'EvieChatMessage',
        components: { EvieChatMessageUserBubble, EvieChatMessageAssistantBubble },
        props: {
            message: { type: Object as PropType<EvieThreadMessage>, required: true },
            isLast: { type: Boolean, default: false },
            isSettled: { type: Boolean, default: false },
        },
        emits: [ 'feedback', 'new-chat', 'retry' ],
        computed: {
            isUser(): boolean {
                return this.message.role === ChatMessageRole.USER;
            },
        },
    });
</script>
